// extracted by mini-css-extract-plugin
module.exports = {"timer":"_3veSPs5pvWmE","sliding":"_3SPQ_VkGuhg_","slideUp":"_1NDUy6qFA4sO","link":"_1JW0LoWDIpBA","sent":"fX2BcM4CKzJV","wait":"_1U5P__sZeP_H"};